import type { CrmNoteType } from '@plato/data/prisma';
import type { TranslationFunction } from '../../../lib/hooks/use-locale.ts';

export function getNoteTypeLabel(noteType: CrmNoteType, t: TranslationFunction): string {
    switch (noteType) {
        case 'VISIT':
            return t('notes__type__visit', { ns: 'notes' });
        case 'PHONE_CALL':
            return t('notes__type__phone_call', { ns: 'notes' });
        case 'NOTE':
        default:
            return t('notes__type__note', { ns: 'notes' });
    }
}
